
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import SignWith from "../components/Auth/SignWith";
import AuthBackground from "../components/ReuseableCompos/AuthBackground";
import useTranslation from "next-translate/useTranslation";
import SignUpForm from "../components/ReuseableCompos/AuthModal/SignUpForm";
const Signup = () => {
    const { t } = useTranslation("common");
    return (<>
      <AuthBackground />
      <section className="container d-flex align-items-center pt-7 pb-3 pb-md-4" style={{ flex: "1 0 auto" }}>
        <div className="w-100 pt-3">
          <div className="row">
            <div className="col-lg-4 col-md-6 offset-lg-1">
              <div id="signup-view">
                <h1 className="h2 text-center">{t(`sign_up`)}</h1>
                <div className="mb-4">
                  <SignWith />
                </div>

                <SignUpForm fromPage/>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>);
};
export default Signup;

    async function __Next_Translate__getStaticProps__1a13f66bde4__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/signup',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a13f66bde4__ as getStaticProps }
  